import { PayoutsDataGrid } from './management/PayoutsDataGrid';

export default function PayoutsScreen() {
  return (
    <div>
      <PayoutsDataGrid />
    </div>
  );
}
